module.exports = __webpack_public_path__ + "static/media/canceled.3d65751b.svg";